import { createApp } from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"

// if (location.protocol !== "https:") {
//   location.protocol = "https:"
// }
//this line is preventing the project to served in localhost 
//npx --node-options="--openssl-legacy-provider" npm run serve : for running in local

createApp(App).use(store).use(router).mount("#app")
